import styled from 'styled-components';
import { colors } from 'styles/colors';
import { Button } from '~/components';
import { colors as remoteColors } from '~/styles/remoteControlColors';
import { shadows as remoteShadows, shadows } from '~/styles/remoteControlShadows';

export const MachineProfileContainer = styled.div`
  position: relative;
  height: calc(100vh - 70px);

  @media (max-width: 768px) {
    height: calc(100% - 60px);
  }
`;

export const ContainerHeader = styled.div<{ loading?: boolean }>`
  position: relative;
  width: 100%;
  height: 162px;
  background: ${remoteColors.Blue700};
  border-radius: 8px;
  margin-bottom: 8px;
  padding: 16px 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;

  @media (max-width: 768px) {
    border-radius: 0;
  }

  ${({ loading }) => (loading ? `
    & > span, span > span {
      width: 600px;
    }

    @media (max-width: 768px) {
      & > span, span > span {
        width: 100%;
      }
    }
  ` : '')}
`;

export const HeaderTitleContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  height: 34px;
  padding-top: 8px;
`;

export const ContainerPage = styled.div`
  position: relative;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  p, h1, h2, h3 {
    margin: 0;
  }

  @media (max-width: 768px) {
    padding: 0;
    width: auto;
  }
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 130%;
  color: ${remoteColors.White};
  line-clamp: 3;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    text-align: center;
    max-width: calc(100% - 70px);
  }
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 10px;
  color: ${remoteColors.White};

  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-clamp: 1;
  text-overflow: ellipsis;
`;

export const ContainerEconomyModeBar = styled.div`
  width: 100%;
  height: 56px;
  background-color: ${remoteColors.White};
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 8px;
  gap: 4px;
  box-shadow: ${remoteShadows.shadow01};

  h2 {
    font-size: 16px;
    font-weight: 500;
    line-height: 100%;
    color: ${remoteColors.Black900};
  }

  @media (max-width: 768px) {
    margin: 0 24px;
    width: auto;
  }
`;

export const Label = styled.span`
  transition: all 0.2s;
  margin-top: -6px;
  margin-left: 16px;
  margin-right: 16px;
  color: ${colors.Blue700};
  font-size: 11px;
  font-weight: bold;
`;

export const Link = styled.div`
  font-size: 11px;
  line-height: 13px;
  color: #363BC4;
  text-decoration: underline;
  margin-top: 6px;
  cursor: pointer;
`;

export const WifiIconContainer = styled.div`
  background-color: ${remoteColors.Blue02Opacity};
  border-radius: 6px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-left: 1px;
  }

  @media (max-width: 768px) {
    /* Para dispositivos móveis */
    width: 24px;
    height: 24px;
    border-radius: 5px;
  }
`;

export const ConnectionContainer = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${remoteColors.White};

  p {
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
    vertical-align: center;
  }

  @media (max-width: 768px) {
    /* Para dispositivos móveis */
    gap: 6px;

    p {
      font-size: 14px;
      line-height: 16px;
    }
  }
`;

export const SetpointContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  background-color: ${remoteColors.White};
  border-radius: 8px;
  gap: 24px;
  padding: 16px;
  width: 100%;
  box-shadow: ${remoteShadows.shadow01};

  h1 {
    color: ${remoteColors.Black900};
    font-size: 16px;
    font-weight: 600;
    line-height: 180%;
  }

  @media (max-width: 768px) {
    /* Para dispositivos móveis */
    margin: 0 24px;
    width: auto;
  }
`;

export const ControllerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media (max-width: 768px) {
    /* Para dispositivos móveis */
    width: 100%;
  }
`;

export const CurrentTemperatureEnvironmentContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${remoteColors.White};
  width: 310px;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
  }

  p, span {
    font-size: 12px;
    font-weight: 400;
    color: ${remoteColors.Grey500};
  }

  @media (max-width: 768px) {
    /* Para dispositivos móveis */
    background-color: transparent;
    padding: 0;
    align-items: center;
    width: 100%;
  }
`;

export const ScheduleBadgeContainer = styled.div<{ isEmpty: boolean }>`
  height: ${({ isEmpty }) => (isEmpty ? 'auto' : '30px')};
  padding: 4px 12px;
  border-radius: 1000px;
  background-color: ${remoteColors.Grey200};
  display: flex;
  gap: 12px;

  div {
    display: flex;
    gap: 4px;
    align-items: center;
  }

  p {
    font-size: 12px;
    font-weight: 600;
    line-height: 180%;
    font-variant-numeric: tabular-nums;
    color: ${remoteColors.Grey500};
  }
`;

export const ScheduleHoursTitle = styled.h2`
  color: ${remoteColors.Black900};
  font-weight: 500;
  font-size: 16px;
  text-align: center;
`;

export const RoundedButton = styled.button`
  cursor: pointer;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 9999px;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 24px;
    height: 24px;
  }

  &:disabled {
    background-color: ${remoteColors.Grey200};
    color: ${remoteColors.Grey400} !important;
  }
`;

export const SetpointButton = styled(RoundedButton)`
  background-color: ${remoteColors.Blue700};
  color: ${remoteColors.White};
`;

export const PowerButton = styled(RoundedButton)<{off: boolean}>`
  margin-top: 126px;
  z-index: 1;
  color: ${({ off }) => (off ? remoteColors.Green500 : remoteColors.Red600)};
`;

export const SetpointLabel = styled.p<{ color: string; hasDecimal: boolean }>`
  width: 118px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  font-variant-numeric: tabular-nums;
  font-weight: 400;
  font-size: ${({ hasDecimal }) => (hasDecimal ? '35px' : '47px')};
  color: ${({ color }) => color};
  text-align: center;
`;

export const SetpointControllerContent = styled.div`
  height: 208px;
  width: 230px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const IconButton = styled.button`
  margin: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  height: 34px;
  width: 34px;
  border-radius: 4px;
`;

export const ModeMachineContainer = styled.div`
  background-color: ${remoteColors.White};
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;

  button {
    width: 256px;
    height: 56px;
  }
`;

export const ScheduleBadgesContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 768px) {
    /* Para dispositivos móveis */
    align-items: flex-start;
  }
`;

export const ScheduleHoursContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;

  @media (max-width: 768px) {
    /* Para dispositivos móveis */
    margin-left: 24px;
    margin-right: 24px;
  }
`;

export const LoaderContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 5;
  background-color: rgba(239, 241, 244, 0.7);
`;

export const BaseModeMessageContainer = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;

  h2 {
    font-weight: 600;
    font-size: 12px;
    line-height: 180%;
    max-width: 310px;
    color: ${remoteColors.Black900};
    text-align: center;
  }

  p {
    font-weight: 400;
    font-size: 12px;
    color: ${remoteColors.Grey500};
    line-height: 180%;
    text-align: center;
  }

  div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const BlockedModeMessageContainer = styled(BaseModeMessageContainer)`
  h2 {
    font-size: 16px;
    max-width: auto;
  }
`;

export const DisconnectedMessageContainer = styled(BaseModeMessageContainer)`
  border-radius: 8px;
  padding: 16px;
  box-shadow: ${shadows.shadow01};

  @media (max-width: 768px) {
    margin: 0 16px;
  }
`;

export const FooterContainerModal = styled.div`
  display: flex;
  gap: 16px;
  margin-left: auto;

  button {
    height: 54px;
    width: 160px;
  }

  @media (max-width: 768px) {
    /* Para dispositivos móveis */
    margin: 0;
    flex-direction: column;

    button {
      width: auto;
    }
  }

`;

export const LeavePageModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  position: relative;
  padding: 24px;
`;

export const EnvironmentInfo = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;

  h2 {
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
    color: ${remoteColors.White};
  }
`;

export const EnvironmentCardIcon = styled.div`
  height: 24px;
  width: 24px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${remoteColors.Blue900Opacity};
`;

export const SaveButtonContainer = styled.div<{ menuToggle: boolean }>`
  width: ${({ menuToggle }) => (menuToggle ? 'calc(100vw - 260px)' : 'calc(100vw - 70px)')};
  padding: 8px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  background-color: ${colors.White};
  z-index: 2;
  bottom: 0;
  right: 0;
  margin: 0;

  button {
    width: 310px;
  }

  @media (max-width: 768px) {
    /* Para dispositivos móveis */
    width: 100%;

    button {
      width: 100%;
    }
  }
`;

export const OperationButtonLoading = styled.div`
  width: 256px;
  height: 56px;
  border-radius: 8px;
  padding: 16px;
  background-color: ${remoteColors.Grey200};
  display: flex;
  align-Items: center;
  justify-content: center;

  span, span > span {
    width: 192px;
  }


  @media (max-width: 768px) {
    width: 100%;

    span, span > span {
      width: 100%;
    }
  }
`;

export const SetpointTextLoading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  span, span > span {
    width: 310px;
  }

  @media (max-width: 768px) {
    width: 100%;

    span, span > span {
      width: 100%;
    }
  }
`;

export const ErrorStatusCard = styled.div`
  height: 54px;
`;

export const disabledStyleRoundedButton = {
  style: {
    cursor: 'not-allowed',
    backgroundColor: remoteColors.Grey200,
    color: remoteColors.Grey400,
  },
};

export const PowerButtonVentilation = styled(Button)<{ loading?: boolean }>`
  border: 1px solid ${remoteColors.Red600};
  background: transparent;
  width: 160px;
  height: 34px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  color: ${remoteColors.Red600};
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: none;
  padding-left: 7px;
  
  ${({ loading }) => loading && `
    pointer-events: none;
    cursor: not-allowed;
  `}
`;

export const PowerButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
`;

export const VentilationContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
